import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavController } from '@ionic/angular';
import { AuthenticationFacade } from '@symphony-solo/domain/authentication/src';
import { CompanyGroupFacade } from '@symphony-solo/domain/company-group/src';
import { AlertService } from '@symphony-solo/shared/alert/src';
import { Icons } from '@symphony-solo/shared/common-ui/src';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'symphony-solo-general-header',
  templateUrl: './general-header.component.html',
  styleUrls: ['./general-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeneralHeaderComponent implements OnInit {
  public viewModel$: Observable<any> = combineLatest([this.companyGroupFacade.companyGroupInfo$]).pipe(
      map(([companyGroupInfo]) => {
        return {
          companyGroupInfo,
        };
      })
    );
  @Input() public title: string;
  @Input() public isTitle: boolean;
  @Input() public backURL: string;
  @Input() public classes: string[];
  @Input() public responsive: string;
  @Input() public hideLogo: boolean;
  @Input() public hideBackButton: boolean;
  @Input() public hideHomeButton: boolean;
  @Input() public saveChanges: boolean;
  @Input() public page: string;
  @Input() public hideMenuButton: boolean;
  @Input() public showHomeIconAnyCase: boolean;
  @Input() public showInfoIcon = false;
  @Output() public infoIconClicked = new EventEmitter<void>();
  public disabledBtn = false;
  public companyLogo: string;
  public clickAndCollectIcon = Icons.svg.clickAndCollect;
  public iconsSvg = Icons.svg;

  constructor(
    public authenticationFacade: AuthenticationFacade,
    private navCtrl: NavController,
    private cdf: ChangeDetectorRef,
    private alertService: AlertService,
    private companyGroupFacade: CompanyGroupFacade
  ) {}

  public ngOnInit(): void {
  }

  public goBack(): void {
    const yesButton = {
      text: 'yes',
      cssClass: 'okButton centerButton',
      handler: () => {
        if (this.backURL) {
          this.navCtrl.navigateBack(this.backURL);
        } else {
          this.navCtrl.back();
        }
      },
    };
    const noButton = {
      text: 'no',
      cssClass: 'okButton centerButton',
      handler: () => {
        return;
      },
    };
    if (this.saveChanges) {
      this.alertService.presentAlert('Alert', 'Changes you have made will be lost are you sure you wish to leave?', [yesButton, noButton]);
    } else if (this.backURL) {
      this.navCtrl.navigateBack(this.backURL);
    } else {
      this.navCtrl.back();
    }
  }

  public navigateToHome(): void {
    this.disabledBtn = true;
    // this.navCtrl.navigateRoot(SELECT_APP_SIMPLE_TABS);
    this.authenticationFacade.goHomeSuccess();
    setTimeout(() => {
      this.disabledBtn = false;
      this.cdf.detectChanges();
    }, 1000);
  }

  public onInfoIconClick(): void {
    this.infoIconClicked.emit();
  }
}
